<div class="adx-video-controls-container"
     [class]="controlsVisibilityClass"
     (mousemove)="onMouseMove()">

  <div class="adx-controls-bar">
    <!-- Centered Controls Section -->
    <div class="adx-controls-section controls-centered">

      <!-- Video Mute Toggle (only show if sending local video) -->
      <button
        mat-icon-button
        class="adx-control-button"
        *ngIf="call?.hasVideo"
        (click)="toggleVideoMute()"
        [class.muted]="call?.isVideoMuted"
        [matTooltip]="videoMuteTooltip"
        aria-label="Toggle video">
        <fa-icon [icon]="videoMuteIcon"></fa-icon>
      </button>

      <!-- Audio Mute Toggle -->
      <button
        mat-icon-button
        class="adx-control-button"
        (click)="toggleAudioMute()"
        [class.muted]="call?.isMuted"
        [matTooltip]="audioMuteTooltip"
        aria-label="Toggle microphone">
        <fa-icon [icon]="audioMuteIcon"></fa-icon>
      </button>

      <!-- Camera Selection (only show if sending local video) -->
      <button
        mat-icon-button
        class="adx-control-button"
        [matMenuTriggerFor]="cameraMenu"
        [matTooltip]="'ASTIMAX.PHONE.WIDGET.VIDEO.SWITCH_CAMERA' | translate"
        [attr.aria-label]="'ASTIMAX.PHONE.WIDGET.VIDEO.SWITCH_CAMERA' | translate"
        *ngIf="call?.hasVideo && availableCameras.length > 1">
        <fa-icon [icon]="faSyncAlt"></fa-icon>
      </button>

      <mat-menu #cameraMenu="matMenu">
        <button
          mat-menu-item
          *ngFor="let camera of availableCameras"
          (click)="switchCamera(camera.deviceId)">
          <fa-icon [icon]="faVideo"></fa-icon>
          <span>{{ camera.label || (('ASTIMAX.PHONE.WIDGET.VIDEO.CAMERA' | translate) + ' ' + camera.deviceId.slice(0, 8)) }}</span>
        </button>
      </mat-menu>

      <!-- End Call Button -->
      <button
        mat-icon-button
        class="adx-control-button adx-end-call-button"
        (click)="endVideoCall()"
        [matTooltip]="'ASTIMAX.PHONE.WIDGET.VIDEO.CONTROLS.END_CALL' | translate"
        [attr.aria-label]="'ASTIMAX.PHONE.WIDGET.VIDEO.CONTROLS.END_CALL' | translate">
        <fa-icon [icon]="faPhoneSlash"></fa-icon>
      </button>
    </div>
  </div>

  <!-- Keyboard Shortcuts Hint (Optional) -->
  <div class="adx-keyboard-hints" *ngIf="false">
    <span class="adx-hint-item">Ctrl+D: Toggle video</span>
    <span class="adx-hint-item">Ctrl+Shift+D: Toggle audio</span>
    <span class="adx-hint-item">F11: Fullscreen</span>
  </div>
</div>
